import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Grid, Typography } from "@material-ui/core";

// Components
import TermsOfUse from "../sitePolicy/TermsOfUse";
import { useLanguage } from "../../contexts/languageContext";

// Medias
import guidePdfEn from "../../assets/documents/ABC Reference Guide - English.pdf";
import guidePdfAr from "../../assets/documents/ABC Reference Guide - Arabic.pdf";

// Styles
import FooterStyle from "../../assets/styles/materialUI/elements/FooterStyle";

const Footer = () => {
	const classes = FooterStyle();
	const { t } = useTranslation();
	const { direction } = useLanguage();
	const [showTermsOfUse, setShowTermsOfUse] = useState(false);

	const showStatements = (type) => {
		if (type === "terms") setShowTermsOfUse(true);
		else if (type === "mena_website") redirectToMenaWebsite(true);
	};

	const redirectToMenaWebsite = () => {
		const url = "https://menafccg.com/";
		window.open(url, "_blank", "noopener,noreferrer");
	};

	return (
		<Grid>
			<Grid className={classes.footerRoot}>
				<Grid className={classes.topStrip} />
				<Grid className={classes.bottomBar}>
					<Typography className={classes.footerLinks} dir={"rtl"} style={{}}>
						<a className={classes.links} onClick={() => showStatements("terms")}>
							{t("footer.terms")}
						</a>{" "}
						|{" "}
						<a
							className={classes.links}
							onClick={() =>
								direction === "ltr"
									? window.open(guidePdfEn, "_blank")
									: window.open(guidePdfAr, "_blank")
							}
						>
							{t("footer.referenceGuide")}
						</a>{" "}
						|{" "}
						<a className={classes.links} onClick={redirectToMenaWebsite}>
							{t("footer.website")}
						</a>
					</Typography>
				</Grid>
			</Grid>
			<TermsOfUse
				open={showTermsOfUse}
				onClose={() => setShowTermsOfUse(false)}
				onConfirm={() => setShowTermsOfUse(false)}
				source={t("terms.close")}
			/>
		</Grid>
	);
};

export default Footer;
